import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const filtersUIMessages = {
  filtersHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "indexPage.advancedFilters.header"
  }),
  panelHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "indexPage.advancedFilters.panelHeader"
  }),
  viewerEmptyFilters: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "indexPage.advancedFilters.viewerEmptyFilters"
  }),
  viewerEmptyFiltersForSkipEmptyFiltersState: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "indexPage.advancedFilters.viewerEmptyFiltersInEditMode"
  })
};
export const BannerBodyText = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "indexPage.advancedFilters.bannerBodyText"
});
export const BannerTitleText = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "indexPage.advancedFilters.bannerTitleText"
});